jQuery(document).ready(function( $ ) {

$(window).on('load resize orientationchange', function() {
	if ($('#infotrack').length) {
		const infotrackWidth = $('#infotrack .infotrack__text .text').width() + 100;
		const windowWidth = $(window).width();
		let animationDurationPlusDelayForOffsetting = 23000; // 23 seconds equal 20 seconds of animation duration + 3 seconds of animation delay

		if (767 < windowWidth && windowWidth < 992) {
			 animationDurationPlusDelayForOffsetting = 28000; // 28 seconds equal 25 seconds of animation duration + 3 seconds of animation delay
		} else if (windowWidth > 991) {
			 animationDurationPlusDelayForOffsetting = 33000; // 33 seconds equal 30 seconds of animation duration + 3 seconds of animation delay
		}

		if (infotrackWidth > windowWidth) {
			$('#infotrack').addClass('wider');
			$('#infotrack').removeClass('narrower');
			setTimeout(function() {
				$('#infotrack').addClass('animation2');
			}, animationDurationPlusDelayForOffsetting);
		} else {
			$('#infotrack').removeClass('wider');
			$('#infotrack').addClass('narrower');
			$('#infotrack').removeClass('animation2');
		}
	}
});


});